import React from "react";
import styled from "styled-components";
import { NavLink } from "react-router-dom";
import { isMobile } from "./style";

const Footer: React.FC = () => {
  return (
    <Footers>
      <Nav>
        <NavLinks
          className={({ isActive }) => (isActive ? "active" : "")}
          to="/"
        >
          대머리 게임
        </NavLinks>
      </Nav>
      <>
        <NavLinks
          className={({ isActive }) => (isActive ? "active" : "")}
          to="/dev"
        >
          개발자
        </NavLinks>
      </>
    </Footers>
  );
};

export default Footer;

const Footers = styled.div`
  background: #ffe3e3;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 95px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);

  ${isMobile} {
    height: 70px;
  }
`;

const Nav = styled.div`
  border-right: 1px solid #f9cccc;
`;

const NavLinks = styled(NavLink)`
  color: #d8abab;
  font-family: "GmarketSansBold";
  font-size: 23px;
  font-weight: 700;
  text-decoration: none;

  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  &:hover {
    color: #ca9292;
  }

  &.active {
    color: #ca9292;
  }

  ${isMobile} {
    font-size: 18px;
  }
`;
